import Http from '@/classes/http/Http'
import Transform from '@/classes/form/Transform'

export default {
  getIssues () {
    return Http.get({
      url: 'issues'
    })
  },

  patchIssue (issueId, formAndFileData) {
    let data = Transform.createMultipartFormData(formAndFileData)
    return Http.patch({
      url: `issues/${issueId}`,
      data: data
    })
  },

   patchIssueReviewComment (issueId, data) {
    return Http.post({
      url: `issues/${issueId}/comment`,
      data: data
    })
  },

  getIssuesForPopService () {
    return Http.get({
      url: `issues/services/pop/templates`
    })
  },

  postIssuesForPopService (issueIds, data) {
    data = Transform.createMultipartFormData(data)
    data.append('issues', JSON.stringify(issueIds))
    return Http.post({
      url: `issues/services/pop/templates`,
      data: data
    })
  }
}
